export default __webpack_public_path__ + "static/media/cancer_360.2ca3bb42.png";